export default __webpack_public_path__ + "static/media/nav-header.e0501365.png";